'use client';

import { Button, DialogFooter } from '@shared/components/shadcn';
import { FieldMessage } from '../form-controls/FieldMessage/FieldMessage';
import { ToggleGroup } from '../form-controls/ToggleGroup/ToggleGroup';
import { ContinueButton } from '../Forms/Registration/components/ContinueButton/ContinueButton';
import { StepLayout } from '../Forms/Registration/components/StepLayout/StepLayout';
import type { ProductPreferencesActionsProps, ProductPreferencesProps } from './types';

function ProductPreferencesActions({
  onContinue,
  onNoOffers,
  continueButtonText,
  noOffersButtonText,
  continueButtonTrackName,
  selectedCount,
  footerContainerElement: FooterWrapper = 'div',
  footerContainerProps = {},
}: ProductPreferencesActionsProps) {
  return (
    <FooterWrapper {...footerContainerProps} data-track-container="Actions">
      <ContinueButton onClick={onContinue} data-track-name={continueButtonTrackName ?? (selectedCount === 0 ? 'All Options' : 'Selected Options')}>
        {continueButtonText}
      </ContinueButton>
      <Button onClick={onNoOffers} variant="secondary" data-track-name="No Options" type="button" data-testid="no-options-button">
        {noOffersButtonText}
      </Button>
    </FooterWrapper>
  );
}

function ProductPreferences({
  value,
  onChange,
  options,
  error,
  onContinue,
  onNoOffers,
  continueButtonText,
  noOffersButtonText,
  continueButtonTrackName,
  fieldId = 'productPreferences-error',
  stepLayout,
  className = '',
  addFooterElement = false,
}: ProductPreferencesProps) {
  const selectedCount = value?.length ?? 0;
  const content = (
    <div className="flex flex-col w-full min-h-0 flex-1 md:flex-none gap-8">
      <div className="flex flex-col align-center">
        <ToggleGroup value={value ?? []} onValueChange={onChange} options={options} hasError={!!error} className="mt-2" data-track-container="Options" />
        <FieldMessage id={fieldId} message={error} messageType={error ? 'error' : undefined} />
      </div>

      <ProductPreferencesActions
        onContinue={onContinue}
        onNoOffers={onNoOffers}
        continueButtonText={continueButtonText}
        noOffersButtonText={noOffersButtonText}
        continueButtonTrackName={continueButtonTrackName}
        selectedCount={selectedCount}
        footerContainerElement={addFooterElement ? DialogFooter : 'div'}
        footerContainerProps={addFooterElement ? { className: 'flex-col' } : { className: 'flex flex-col gap-4 mt-auto md:mt-0' }}
      />
    </div>
  );

  if (stepLayout) {
    return (
      <StepLayout {...stepLayout} className={className}>
        {content}
      </StepLayout>
    );
  }

  return content;
}

export { ProductPreferences, ProductPreferencesActions };
